import { Component, Input } from '@angular/core';

@Component({
    selector: 'traceable-component-link',
    templateUrl: './traceable-component-link.component.html',
    styleUrls: ['./traceable-component-link.component.css'],
    standalone: false
})
export class TraceableComponentLinkComponent {
  @Input() componentId: number | null | undefined = null;
  @Input() source: string | null | undefined = null;
}
